// ============================================================================
// CONSTANTS
// ============================================================================

const ITEMS_PER_PAGE = 36;

// Sort configuration
const SORT_OPTIONS = [
  { name: 'Relevance', value: 'relevance' },
  { name: 'Price: Low to High', value: 'price-asc' },
  { name: 'Price: High to Low', value: 'price-desc' },
  { name: 'Top Sellers', value: 'top-sellers' },
  { name: 'Newest to Oldest', value: 'new-to-old' },
];

const SORT_MAPPING = {
  'price-asc': 'price asc',
  'price-desc': 'price desc',
  'relevance': '',
  'top-sellers': 'p_isPart asc,best_seller desc',
  'new-to-old': 'p_isPart asc,p_maxWebLiveDate desc'
};

// Facet processors for different facet types
const FACET_PROCESSORS = {
  // Category facets use cat_id for value, cat_name for display
  category: (option) => ({
    value: option.cat_id,
    text: option.cat_name,
    count: option.count
  }),

  // Number range facets (like Price) use start/end for value, formatted string for display
  numberRange: (option) => {
    const start = option.start === "*" ? "0" : option.start;
    const end = option.end === "*" ? "+" : option.end;
    return {
      value: `${start}-${end}`,
      text: `$${start} - $${end}`,
      count: option.count
    };
  },

  // Standard facets use name for both value and display
  default: (option) => ({
    value: option.name,
    text: option.name,
    count: option.count
  })
};

//  Storage array for lookup
let facetsLookup = [];

document.addEventListener("DOMContentLoaded", function () {
    // ============================================================================
    // INITIALIZATION
    // ============================================================================

    // Generate or retrieve a persistent session ID
    const sessionID = sessionStorage.getItem("sessionID") || Math.random().toString(36).substring(2, 10);
    sessionStorage.setItem("sessionID", sessionID);
    const requestID = `${new Date().toISOString()}-${sessionID}`;
    window.dataLayer = window.dataLayer || [];

    // ============================================================================
    // DOM ELEMENTS
    // ============================================================================
    const container = document.getElementById("br-search-results");
    const spinner = document.getElementById("search-spinner");
    const resultsFilter = document.getElementById("search-results-filter");
    const paginationElements = document.querySelectorAll("nbhd-pagination-search");
    const searchBar = document.querySelectorAll("nbhd-search");
    const headerNbhdSearch = document.querySelectorAll('.nbhd-search-header');
    const headerSearchButtons = document.querySelectorAll('.header__icon--search');
    const autosuggestElement = document.querySelector("nbhd-autosuggest");
    const searchContainer = document.querySelector(".search-container-bloomreach");
    const emptySearchContainer = document.querySelector(".empty-search-container-bloomreach");


    headerSearchButtons.forEach(searchButton => {
      searchButton.addEventListener('click', () => {
        headerNbhdSearch.forEach(search => {
          search?.focusInput();
        });
      });
    });

    // ============================================================================
    // STATE VARIABLES
    // ============================================================================
    // Get search query from URL
    let q = new URLSearchParams(window.location.search).get("q");

    // If no search query provided, use wildcard to show all products
    if (!q) {
        q = "*";
        // console.log("No search query provided, using wildcard search:", q);
    }

    // Filter, sort, and pagination state
    let selectedFilters = [];
    let currentSort = 'relevance';
    let currentPage = 1;

    // Collection filters (always applied, cannot be removed by user)
    let collectionFilters = [];
    // ============================================================================
    // UTILITY FUNCTIONS
    // ============================================================================

    // Debounce function for API calls
    function debounce(fn, delay = 260) {
        let timerId = null;
        return (...args) => {
            clearTimeout(timerId);
            timerId = setTimeout(() => fn(...args), delay);
        };
    }

    // Collection filter manager - single source of truth
    const CollectionFilterManager = {
        filters: [],
        facetNames: [],

        parse(container) {
            if (!container?.dataset?.collectionFilters) {
                this.filters = [];
                this.facetNames = [];
                return;
            }

            this.filters = JSON.parse(container.dataset.collectionFilters);
            // console.log('🔧 Collection filters loaded:', this.filters);

            // Extract facet names once
            this.facetNames = this.filters.map(filter => {
                const cleanFilter = this.extractFilterValue(filter);
                const match = cleanFilter.match(/^([^:]+):/);
                return match ? match[1] : null;
            }).filter(Boolean);

            // console.log('🔧 Facet names to exclude:', this.facetNames);
        },

        extractFilterValue(filter) {
            // Extract parameter name and value from filter string
            // Examples: "fq=Collection:\"Align\"" or "efq=Collection:\"Align\""
            const match = filter.match(/^([^=]+)=(.+)$/);
            if (match) {
                return match[2]; // Return just the value part
            }
            return filter; // Fallback to original if no match
        },

        extractParamName(filter) {
            // Extract parameter name from filter string
            // Examples: "fq=Collection:\"Align\"" or "efq=Collection:\"Align\""
            const match = filter.match(/^([^=]+)=(.+)$/);
            if (match) {
                return match[1]; // Return parameter name (fq, efq, etc.)
            }
            return 'fq'; // Default fallback
        },

        addToParams(params) {
            // console.log('🔧 Adding collection filters to API params:', this.filters);
            this.filters.forEach(filter => {
                const paramName = this.extractParamName(filter);
                const cleanFilter = this.extractFilterValue(filter);
                // console.log(`🔧 Filter: "${filter}" -> Param: "${paramName}", Value: "${cleanFilter}"`);
                params.append(paramName, cleanFilter);
            });
        },

        getFacetNames() {
            return this.facetNames;
        }
    };



    // ============================================================================
    // STATE INITIALIZATION
    // ============================================================================

    // Initialize collection filters
    CollectionFilterManager.parse(container);

    // For collection pages, use collection title as the display term
    const displayTerm = q === "*" ? (container?.dataset?.collectionTitle || "*") : q;

    // console.log("🔍 Search initialized - Query:", q, "Container:", !!container, "Filter:", !!resultsFilter, "Collection Filters:", collectionFilters.length, "Display Term:", displayTerm);

    // Set the search value on the search bar - empty for collection pages
    if (searchBar) {
        searchBar.forEach(bar => {
            bar.setAttribute('search-value', q === "*" ? "" : q);
        });
    }

    // Simple URL parameter management
    function updateURLWithFilters(filters, sort = '') {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);

        // Clear existing fq params
        params.delete('fq');

        // Add new fq params
        filters.forEach(filter => {
            params.append('fq', filter);
        });

        // Add discontinued parameter to URL
        const showDiscontinued = selectedFilters.some(filter =>
            filter.facetKey === "discontinued" && filter.value === true
        );
        if (showDiscontinued) {
            params.set('discontinued', 'true');
        } else {
            params.delete('discontinued');
        }

        // Update sort parameter
        if (sort && sort !== 'relevance') {
            params.set('sort', sort);
        } else {
            params.delete('sort');
        }

        // Update page parameter (only if not page 1)
        if (currentPage > 1) {
            params.set('page', currentPage.toString());
        } else {
            params.delete('page');
        }

        // Build new URL
        const newURL = url.pathname + '?' + params.toString();

        // Only update URL if it's different from current URL
        if (newURL !== window.location.pathname + window.location.search) {
            window.history.pushState({}, '', newURL);
            // console.log('Updated URL with filters:', filters, 'sort:', sort, 'page:', currentPage);
        } else {
            // console.log('URL unchanged, skipping update');
        }
    }

    function loadFiltersFromURL() {
        const urlParams = new URLSearchParams(window.location.search);
        const fqParams = urlParams.getAll('fq');
        const sortParam = urlParams.get('sort');
        const discontinuedParam = urlParams.get('discontinued');
        const pageParam = urlParams.get('page');

        // console.log('Loading filters from URL:', fqParams);
        // console.log('Loading sort from URL:', sortParam);
        // console.log('Loading discontinued from URL:', discontinuedParam);
        // console.log('Loading page from URL:', pageParam);

        // Load regular filters
        if (fqParams.length > 0) {
            selectedFilters = parseFiltersFromURL(fqParams);
            // console.log('Parsed selected filters:', selectedFilters);
        } else {
            selectedFilters = [];
        }

        // Load discontinued filter
        if (discontinuedParam === 'true') {
            const discontinuedFilter = {
                facetKey: "discontinued",
                facetTitle: "Discontinued",
                filterKey: "discontinued",
                label: "Show Discontinued Products",
                selected: true,
                value: true
            };
            selectedFilters.push(discontinuedFilter);
            // console.log('Added discontinued filter from URL');
        }

        if (sortParam) {
            currentSort = sortParam;
            // console.log('Set current sort from URL:', currentSort);
        } else {
            currentSort = 'relevance';
        }

        // Load page parameter
        if (pageParam) {
            const pageNum = parseInt(pageParam, 10);
            if (!isNaN(pageNum) && pageNum > 0) {
                currentPage = pageNum;
                // console.log('Set current page from URL:', currentPage);
            } else {
                currentPage = 1;
            }
        } else {
            currentPage = 1;
        }

        // Update pagination components with loaded sort
        updatePaginationSort();
    }

    function parseFiltersFromURL(fqParams) {
        const filters = [];

        fqParams.forEach(fq => {
            // Parse: "Collection:"Aberdeen" OR "Adeline""
            const match = fq.match(/^([^:]+):(.+)$/);
            if (match) {
                const facetTitle = match[1];
                const values = match[2].split(' OR ').map(v =>
                    v.replace(/^"|"$/g, '') // Remove quotes
                );

                // Create FilterDataEmitted objects
                values.forEach(value => {
                    filters.push({
                        facetKey: facetTitle.toLowerCase().replace(/\s+/g, '-'),
                        facetTitle: facetTitle,
                        filterKey: value,
                        label: value,
                        selected: true,
                        value: value
                    });
                });
            }
        });

        return filters;
    }

    // Load filters from URL on page load
    loadFiltersFromURL();

    // Handle browser back/forward navigation
    window.addEventListener('popstate', function(event) {
        // console.log('Browser navigation detected, reloading filters from URL');

        // Reload query from URL
        const newQuery = new URLSearchParams(window.location.search).get("q");
        q = newQuery || "*";
        // console.log('Reloaded query from URL:', q);

        // Update search bar with new query - empty for collection pages
        if (searchBar) {
            searchBar.forEach(bar => {
                bar.setAttribute('search-value', q === "*" ? "" : q);
            });
        }

        // Clear selected filters if query changed completely (not just filters/sort)
        const urlParams = new URLSearchParams(window.location.search);
        const fqParams = urlParams.getAll('fq');
        const sortParam = urlParams.get('sort');

        // If no filters in URL, clear selectedFilters
        if (fqParams.length === 0) {
            selectedFilters = [];
            // console.log('Cleared selected filters - no filters in URL');
        }

        // Load filters and sort from URL
        loadFiltersFromURL();

        // Update pagination components with new query
        updatePaginationSort();

        // Re-execute search with loaded filters and updated query
        const start = 0; // Reset to first page
        debouncedExecuteSearch(q, start, ITEMS_PER_PAGE, currentSort);
    });

    // Function to update pagination components with current sort
    function updatePaginationSort() {
        paginationElements.forEach(element => {
            element.sortOptions = SORT_OPTIONS;
            element.setAttribute('term', displayTerm);
            element.setAttribute('sort', currentSort);
        });
    }

    // Set up pagination event listeners once during initialization
    paginationElements.forEach(element => {
        element.addEventListener('page-changed', handlePageChange);
        element.addEventListener('sort-changed', handleSortChange);
    });

    // Set initial pagination state
    updatePaginationSort();

    // Add event listener for facet filter
    if (resultsFilter) {
      resultsFilter.addEventListener('filter-change', handleFilterChange);
    }

    // Add event listener for search bar (both search page and header)
    if (searchBar) {
      searchBar.forEach(bar => {
        bar.addEventListener('search-submit', handleSearchSubmit);
        bar.addEventListener('search-input', handleSearchInput);
      });
    }

    // Also handle header search if we're not on search page
    const headerSearch = document.querySelector('header nbhd-search');
    if (headerSearch && !window.location.pathname.includes('/search')) {
      headerSearch.addEventListener('search-submit', handleSearchSubmit);
      headerSearch.addEventListener('search-input', handleSearchInput);
    }

    // Add event listener for autosuggest "See more results" button
    if (autosuggestElement) {
      autosuggestElement.addEventListener('autosuggest-see-more', handleAutosuggestSeeMore);
    }

    // Callback function for page changes
    function handlePageChange(event) {
      const page = event.detail.page;
      // console.log('Page changed:', page);

      // Update current page
      currentPage = page;

      // Calculate start position for the new page
      const start = (page - 1) * ITEMS_PER_PAGE;

      // Execute new search with updated pagination
      debouncedExecuteSearch(q, start, ITEMS_PER_PAGE, currentSort);
    }

    // Callback function for sort changes
    function handleSortChange(event) {
      const sortValue = event.detail.value;
      // console.log('Sort changed:', sortValue);

      // Update current sort (keep UI format)
      currentSort = sortValue;

      // Reset to page 1 when sort changes
      currentPage = 1;

      // Update pagination components with new sort
      updatePaginationSort();

      // Execute new search with sort parameter and reset to page 1
      debouncedExecuteSearch(q, 0, ITEMS_PER_PAGE, currentSort);
    }



    // Callback function for filter changes
    function handleFilterChange(event) {
      // console.log("Filter changed event:", event.detail.selectedFilters);
      // console.log("🔧 Filter selection changed - processing new filter state");

      // Remove duplicates from incoming selectedFilters
      const uniqueSelectedFilters = event.detail.selectedFilters.filter((filter, index, self) =>
        index === self.findIndex(f =>
          f.facetTitle === filter.facetTitle &&
          f.value === filter.value
        )
      );

      // console.log('Selected filters:', uniqueSelectedFilters);

      // Update selectedFilters, preventing duplicates
      selectedFilters = uniqueSelectedFilters;

      // Reset to page 1 when filters change
      currentPage = 1;

      // Execute search - URL will be updated after response comes back
      debouncedExecuteSearch(q, 0, ITEMS_PER_PAGE, currentSort);
      // console.log('🔧 Global filter state updated - executing new search');
    }

    // Callback function for search submit
    function handleSearchSubmit(event) {
      const searchValue = event.detail.value;
      // console.log('Search submitted:', searchValue);

      // Navigate to search results page with the new search term
      if (searchValue && searchValue.trim()) {
        const searchUrl = `/search?q=${encodeURIComponent(searchValue.trim())}`;
        window.location.href = searchUrl;
      }
    }

    // Callback function for autosuggest "See more results" button
    function handleAutosuggestSeeMore(event) {
      // console.log('🔍 Autosuggest "See more results" clicked:', event);
      // console.log('Event detail:', event.detail);

      // Navigate to search page with the term from autosuggest
      if (event.detail && event.detail.term) {
        const searchUrl = `/search?q=${encodeURIComponent(event.detail.term)}`;
        // console.log('🔍 Navigating to search page:', searchUrl);
        window.location.href = searchUrl;
      }
    }

    // Function to make autosuggest API call
    function makeAutosuggestRequest(searchValue) {
      // Get _br_uid_2 from session storage
      const pxid_storage = sessionStorage.getItem('_br_uid_2') || "uid=7797686432023:v=11.5:ts=1428617911187:hc=55";

      const autosuggestParams = new URLSearchParams({
        q: searchValue.trim(),
        fl: "pid",
        ref_url: document.referrer,
        url: window.location.href,
        request_id: requestID,
        pxid: pxid_storage
      });

      const autosuggestURL = `/apps/br-suggest?${autosuggestParams.toString()}`;

      // console.log('🔍 Autosuggest request:', autosuggestURL);

      return fetch(autosuggestURL)
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then(data => {
          // console.log('Autosuggest response:', data);
          const transformedData = transformAutosuggestData(data, searchValue.trim());
          updateAutosuggestionElement(transformedData);
        })
        .catch(error => {
          console.error('Error fetching autosuggest data:', error);
        });
    }

    // Create debounced version of the API call
    const debouncedAutosuggest = debounce(makeAutosuggestRequest, 260);

    // Create debounced version of the main search
    const debouncedExecuteSearch = debounce(executeSearch, 260);

    // Function to handle search input changes
    function handleSearchInput(event) {
      const searchValue = event.detail.value;
      // console.log('Search input value:', searchValue);

      // Only make autosuggest request if there's a search value with at least 3 characters
      if (searchValue && searchValue.trim().length > 2) {
        // Use debounced API call
        debouncedAutosuggest(searchValue);
      } else {
        // Clear autosuggestion if less than 3 characters or empty
        if (autosuggestElement) {
          autosuggestElement.breadcrumbs = [];
          autosuggestElement.products = [];
          autosuggestElement.categories = [];
          autosuggestElement.term = searchValue.trim();
        }
      }
    }

    // Function to transform autosuggest API response to required format
    function transformAutosuggestData(data, searchTerm) {
      const suggestionGroup = data.suggestionGroups?.[0];
      if (!suggestionGroup) {
        return {
          breadcrumbs: [],
          facets: [],
          products: [],
          searchTerm: searchTerm
        };
      }

      // Transform breadcrumbs (using query suggestions)
      const breadcrumbs = transformQuerySuggestionsToBreadcrumbs(suggestionGroup.querySuggestions || [], searchTerm);

      // Create comprehensive categories from both attribute suggestions and product data
      const categories = createCategoriesFromAutosuggestData(
        suggestionGroup.searchSuggestions || [],
        suggestionGroup.attributeSuggestions || [],
        searchTerm
      );

      // Transform products (using search suggestions)
      const products = transformSearchSuggestionsToProducts(suggestionGroup.searchSuggestions || []);

      // Get the first query suggestion for the term
      const firstQuerySuggestion = suggestionGroup.querySuggestions?.[0]?.query || searchTerm;

      return {
        breadcrumbs,
        facets: categories, // Use the new categories
        products,
        searchTerm: firstQuerySuggestion
      };
    }

    // Function to create comprehensive categories from autosuggest data
    function createCategoriesFromAutosuggestData(searchSuggestions, attributeSuggestions = [], searchTerm = '') {
      const categories = [];

      // 1. CATEGORY - from attribute suggestions (API's structured data)
      if (attributeSuggestions.length > 0) {
        const categoryItems = attributeSuggestions.slice(0, 5).map(attr => ({
          label: attr.name,
          href: `/search?q=${encodeURIComponent(searchTerm)}&fq=category:"${encodeURIComponent(attr.value)}"`
        }));

        categories.push({
          title: "CATEGORY",
          items: categoryItems
        });
      }

      // 2. COLLECTION - from product collection names (first 4 products, top 3 results)
      const allCollections = new Set();
      searchSuggestions.slice(0, 4).forEach(product => {
        if (product.p_collectionName) {
          allCollections.add(product.p_collectionName);
        }
      });

      if (allCollections.size > 0) {
        const collectionItems = Array.from(allCollections).slice(0, 3).map(collection => ({
          label: collection,
          href: `/search?q=${encodeURIComponent(searchTerm)}&fq=${encodeURIComponent('Collection')}:"${encodeURIComponent(collection)}"`
        }));

        categories.push({
          title: "COLLECTION",
          items: collectionItems
        });
      }

      // 3. FINISH - from sku_color_group of first 4 products
      const allColorGroups = new Set();
      searchSuggestions.slice(0, 4).forEach(product => {
        if (product.variants && Array.isArray(product.variants)) {
          product.variants.forEach(variant => {
            if (variant.sku_color_group) {
              allColorGroups.add(variant.sku_color_group);
            }
          });
        }
      });

      if (allColorGroups.size > 0) {
        const finishItems = Array.from(allColorGroups).slice(0, 3).map(colorGroup => ({
          label: colorGroup.charAt(0).toUpperCase() + colorGroup.slice(1).toLowerCase(),
          href: `/search?q=${encodeURIComponent(searchTerm)}&fq=${encodeURIComponent('Finish Family')}:"${encodeURIComponent(colorGroup.charAt(0).toUpperCase() + colorGroup.slice(1).toLowerCase())}"`
        }));

        categories.push({
          title: "FINISH FAMILY",
          items: finishItems
        });
      }

      return categories;
    }

    // Function to transform query suggestions to breadcrumbs
    function transformQuerySuggestionsToBreadcrumbs(querySuggestions, searchTerm) {
      return querySuggestions.slice(0, 4).map(suggestion => ({
        label: suggestion.displayText,
        href: `/search?q=${encodeURIComponent(suggestion.query)}`
      }));
    }

    // Function to transform attribute suggestions to facets
    function transformAttributeSuggestionsToFacets(attributeSuggestions) {
      return attributeSuggestions.slice(0, 3).map(attr => ({
        facetName: attr.name,
        facetValues: [
          {
            label: attr.value,
            href: `/search?fq=${encodeURIComponent(attr.name)}:"${encodeURIComponent(attr.value)}"`
          }
        ]
      }));
    }

    // Function to transform search suggestions to product cards
    function transformSearchSuggestionsToProducts(searchSuggestions) {
      const transformedProducts = searchSuggestions.slice(0, 8).map(product => ({
        title: product.description || '',
        model: product.pid || '',
        media: {
          src: product.v_thumb_image || '',
          alt: product.title || product.description || '',
          type: 'image'
        },
        href: getProductUrl(product),
        price: formatCurrency(product.sale_price || product.price_range?.[0] || 0),
        discontinued: product.v_statusFlag?.includes('discontinued') || false,
        status: product.v_stockLevel || 'Unknown',
        v_requiresAPart_flag: product.v_requiresAPart_flag || 'false'
      }));

      // console.log('🔍 Products being passed to autosuggest:', transformedProducts);
      return transformedProducts;
    }

    // Function to update the autosuggestion element
    function updateAutosuggestionElement(data) {
      if (!autosuggestElement) {
        console.error('Autosuggestion element not found');
        return;
      }

      // Update the element properties with the correct structure
      autosuggestElement.breadcrumbs = data.breadcrumbs;
      autosuggestElement.products = data.products;
      autosuggestElement.categories = data.facets; // facets map to categories
      autosuggestElement.term = data.searchTerm;

      // console.log('🔍 Autosuggest updated with search suggestions and category filters');
    }

    // Function to update pagination with actual results
    function updatePagination(totalResults, currentPage = 1, correctedQuery = null) {
      const totalPages = Math.ceil(totalResults / ITEMS_PER_PAGE);
      // console.log("📊 Pagination updated with search results");

      paginationElements.forEach(element => {
          element.setAttribute('current', currentPage.toString());
          element.setAttribute('total', totalPages.toString());
          element.setAttribute('results', totalResults.toString());
          if (correctedQuery) {
              element.setAttribute('term', correctedQuery);
          } else {
              element.setAttribute('term', displayTerm);
          }
      });

      // console.log("📄 Pagination components updated");
    }

    // Function to build the search query parameters
    function buildSearchParams(query, start = 0, rows = ITEMS_PER_PAGE, sort = '') {
      // Get _br_uid_2 from session storage
      const pxid_storage = sessionStorage.getItem('_br_uid_2') || "uid=7797686432023:v=11.5:ts=1428617911187:hc=55";

      const params = new URLSearchParams({
        q: query,
        fl: "pid,url,name,description,thumb_image,v_thumb_image,price,price_range,sale_price_range,sale_price,colors,v_colorUrlLookup,v_image_alt1,v_url,v_urlDev,sizes,skuid,v_requiresAPart_flag,v_statusFlag,v_exclusivityType,v_badges,sku_color,v_colorSwatchUrl,v_webLiveDate,p_maxWebLiveDate,p_isPart",
        ref_url: document.referrer,
        url: window.location.href,
        request_id: requestID,
        start: start.toString(),
        rows: rows.toString(),
        domain_key: "moen",
        pxid: pxid_storage
        // "query.relaxation": "off"
      });

      // Build variant status filter
      const showDiscontinued = selectedFilters.some(filter =>
        filter.facetKey === "discontinued" && filter.value === true
      );
      // console.log('Discontinued selected?', showDiscontinued, 'selectedFilters:', selectedFilters);

      if (showDiscontinued) {
        // Show both active and discontinued products
        params.append('fq', 'v_variantStatus:"ACTIVE" OR "DISCONTINUED"');
      } else {
        // Show only active products
        params.append('fq', 'v_variantStatus:"ACTIVE"');
      }

      // Add collection filters first (always applied, cannot be removed by user)
      CollectionFilterManager.addToParams(params);

      // Build filter queries from selectedFilters and add to params
      const filterQueries = buildFilterQueries(selectedFilters);
      filterQueries.forEach(filter => {
        params.append('fq', filter);
      });

      // Add sort parameter (convert UI format to Bloomreach format)
      const bloomreachSort = SORT_MAPPING[currentSort] || '';
      if (bloomreachSort && bloomreachSort !== '') {
        params.append('sort', bloomreachSort);
      }

      const liveDate = limitFutureDates();
      if (liveDate) {
        params.append('fq', `p_maxWebLiveDate:[* TO ${liveDate}]`);
      }


      return params;
    }

    //Prevent future date items from showing in results
    function limitFutureDates() {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        return `${yyyy}${mm}${dd}`;
    }

    // Function to execute the search
    function executeSearch(query, start = 0, rows = ITEMS_PER_PAGE, sort = '') {
      const baseURL = "/apps/br-search";
      const params = buildSearchParams(query, start, rows, sort);
      const fullURL = `${baseURL}?${params.toString()}`;

      // console.log("🌐 Search request:", fullURL);

      // Show loading spinner
      if (spinner) {
        // spinner.style.display = "block";
        if (spinner.classList.contains('_hide')) {
        spinner.classList.remove('_hide');
      }
      }

      return fetch(fullURL)
        .then((res) => res.json())
        .then((data) => {
          // console.log("🌐 Bloomreach response received");
          // console.log("data", data);
          // console.log("redirected url", data.keywordRedirect?.["redirected url"]);
          // Check for keyword redirect
          if (data?.keywordRedirect?.["redirected url"]) {
            const redirectUrl = data.keywordRedirect["redirected url"];

            // console.log("🔄 Keyword redirect detected:", redirectUrl);

            // Handle relative vs external URLs
            if (redirectUrl.startsWith('/')) {
              // Internal relative URL - redirect as-is
              window.location.href = redirectUrl;
            } else {
              // External URL - add protocol if missing
              const externalUrl = redirectUrl.startsWith('http') ? redirectUrl : `https://${redirectUrl}`;
              window.location.href = externalUrl;
            }
            return; // Stop processing
          }

          const products = data?.response?.docs || [];
          const facets = data?.facet_counts?.facets || [];
          const totalItems = data?.response?.numFound || 0;

          // Store unprocessed facets for lookup use later
          if (facetsLookup.length === 0) {
            facetsLookup = data?.facet_counts?.facets || [];
          }
          console.log('Facets Lookup (load):', facetsLookup);

          // console.log("📦 Search results received - processing products and building filters");

          // Build and set facet filter data only if there are search results
          if (resultsFilter && facets.length > 0 && products.length > 0) {
            // Process facets
            const processedFacets = processFacetData(facets, CollectionFilterManager.getFacetNames());

            // Build UI data for the filter component
            const facetFilterData = buildFacetUI(processedFacets, selectedFilters);

            // Add discontinued products filter at the top
            const discontinuedFilter = {
              title: "", // No parent title
              key: "discontinued",
              filters: [{
                label: "Show Discontinued Products",
                value: true,
                count: 0,
                selected: selectedFilters.some(f => f.facetKey === "discontinued" && f.value === true)
              }],
              expanded: false
            };

            resultsFilter.data = [discontinuedFilter, ...facetFilterData];
            resultsFilter.results = totalItems;
            // console.log('🔧 Facet filters built and UI updated');

            // Update URL with selectedFilters and sort after facets are built
            const filterQueries = buildFilterQueries(selectedFilters);
            updateURLWithFilters(filterQueries, currentSort);

          }

          if (selectedFilters.length > 0) {
            dataLayer.push({
              event: 'apply_filter',
              content_type: 'products',
              filter_term: selectedFilters.map(obj => obj.label).join(", "),
              filter_path: selectedFilters.map(filter => `${filter.facetTitle}>${filter.label}`).join(", ")
            });
          }

          if (window.location.href.includes('sort=')) {
            window.dataLayer.push({
              event: 'sort',
              content_type: 'search results',
              search_term: q,
              sort_term: currentSort
            });
          } else {
            if (q != '*') {
              window.dataLayer.push({
                event: 'search',
                content_type: 'search results',
                search_term: q,
                search_results: data.response?.numFound,
                success: data.response?.numFound > 0 ? '1' : '0'
              });
            }
          }

          if (products.length === 0) {
            // Clear facet filter data when there are no results
            if (resultsFilter) {
              resultsFilter.data = [];
              // console.log("Cleared facet filter data - no search results");
            }

            // Update pagination even when there are no results
            const totalResults = data?.response?.numFound || 0;
            const currentPage = Math.floor(start / ITEMS_PER_PAGE) + 1;
            const correctedQuery = data?.autoCorrectQuery || null;
            updatePagination(totalResults, currentPage, correctedQuery);
            // console.log("No results - Total results from API:", totalResults, "Current page:", currentPage, "Corrected query:", correctedQuery);

            // Hide search container and show empty search container
            if (searchContainer) {
              searchContainer.style.display = 'none';
            }
            if (emptySearchContainer) {
              emptySearchContainer.style.display = 'block';

              // Update the dynamic query in the empty search container
              const emptySearchQueryElement = emptySearchContainer.querySelector('#empty-search-query');
              if (emptySearchQueryElement) {
                const queryToDisplay = q === "*" ? (container?.dataset?.collectionTitle || "all products") : q;
                emptySearchQueryElement.textContent = queryToDisplay;
              }
            }

            return { products: [], facets: [] };
          }

          // Remove spinner and show results
        if (spinner) {
          spinner.classList.add('_hide');
          // spinner.style.display = 'none';
        }

        // Show search container and hide empty search container
        if (searchContainer) {
          searchContainer.style.display = 'block';
        }
        if (emptySearchContainer) {
          emptySearchContainer.style.display = 'none';
        }

          // Build and display products
          displayProducts(products, container);

          // Update pagination with actual results
          const totalResults = data?.response?.numFound || 0;
          const currentPage = Math.floor(start / ITEMS_PER_PAGE) + 1; // Calculate current page from start position
          const correctedQuery = data?.autoCorrectQuery || null;
          updatePagination(totalResults, currentPage, correctedQuery);
          // console.log("Total results from API:", totalResults, "Current page:", currentPage, "Corrected query:", correctedQuery);

          return { products, facets };
        })
        .catch((err) => {
          console.error("❌ Bloomreach fetch error:", err);
          if (spinner) {
            // spinner.style.display = 'none';
            spinner.classList.add('_hide');
          }
          if (container) {
            container.innerHTML = `<p style="color:red;">Error loading search results. Please try again.</p>`;
          }
          return { products: [], facets: [] };
        });
    }

    // Execute initial search with any loaded filters, sort, and page
    const start = (currentPage - 1) * ITEMS_PER_PAGE;
    executeSearch(q, start, ITEMS_PER_PAGE, currentSort);
  });

  // Function to format currency using built-in Intl.NumberFormat
  function formatCurrency(amount) {
    if (!amount && amount !== 0) return 'Price not available';

    // Convert to number if it's a string
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;

    if (isNaN(numAmount)) return 'Price not available';

    // Use built-in currency formatter
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(numAmount);
  }





  // Function to build filter queries from selectedFilters array
  function buildFilterQueries(selectedFilters) {
    // Skip discontinued filter - it's handled separately in buildSearchParams
    const nonDiscontinuedFilters = selectedFilters.filter(filter => filter.facetKey !== "discontinued");

    // Organize filters by facetTitle
    const filterGroups = {};

    nonDiscontinuedFilters.forEach(filter => {
      const category = filter.facetTitle;
      const value = filter.value;

      if (!filterGroups[category]) {
        filterGroups[category] = [];
      }
      filterGroups[category].push(value);
    });

    // Create fq queries for each facetTitle
    const filterQueries = [];

    Object.keys(filterGroups).forEach(category => {
      const values = filterGroups[category];

      if (values.length === 1) {
        // Handle price ranges differently
        if (category === "Price") {
          // Parse the range value (e.g., "25-50" -> "[25 TO 50]")
          const rangeMatch = values[0].match(/(\d+)-(\d+|\+)/);
          if (rangeMatch) {
            const start = rangeMatch[1];
            const end = rangeMatch[2] === '+' ? '*' : rangeMatch[2];
            filterQueries.push(`price:[${start} TO ${end}]`);
          }
        } else {
          // Single filter: "Category:\"Value\""
          const escapedValue = escapeFilterValue(values[0]);
          filterQueries.push(`${category}:"${escapedValue}"`);
        }
      } else {
        // Handle multiple filters
        if (category === "Price") {
          // Multiple price ranges: "price:[0 TO 100] OR [300 TO 400]"
          const priceRanges = values.map(value => {
            const rangeMatch = value.match(/(\d+)-(\d+|\+)/);
            if (rangeMatch) {
              const start = rangeMatch[1];
              const end = rangeMatch[2] === '+' ? '*' : rangeMatch[2];
              return `[${start} TO ${end}]`;
            }
            return null;
          }).filter(Boolean);

          if (priceRanges.length > 0) {
            filterQueries.push(`price:${priceRanges.join(' OR ')}`);
          }
        } else {
          // Multiple filters: "Category:\"Value1\" OR \"Value2\""
          const orQuery = values.map(value => {
            const escapedValue = escapeFilterValue(value);
            return `"${escapedValue}"`;
          }).join(' OR ');
          filterQueries.push(`${category}:${orQuery}`);
        }
      }
    });

    return filterQueries;
  }

  // Function to escape filter values for Bloomreach query
  function escapeFilterValue(value) {
    if (!value) return '';

    // Handle boolean values (like discontinued filter)
    if (typeof value === 'boolean') {
      return value.toString();
    }

    // Convert to string and replace double quotes with escaped quotes
    // This handles cases like "8" Widespread" -> "8\" Widespread"
    return value.toString().replace(/"/g, '\\"');
  }

  // Use global FACET_PROCESSORS constant

  // Process a single facet option based on its structure
  function processFacetOption(option, facet) {
    // console.log(`Processing option for facet ${facet.name}:`, option);

    // Number range facets take precedence - check type first
    if (facet.type === "number_range" && option.start !== undefined && option.end !== undefined) {
      return FACET_PROCESSORS.numberRange(option);
    }

    // Category facets have cat_name property
    if (option.cat_name) {
      return FACET_PROCESSORS.category(option);
    }

    // Standard facets have name property
    if (option.name) {
      return FACET_PROCESSORS.default(option);
    }

    // console.log("Unknown option structure:", option);
    return null;
  }

  // Process all facets and normalize their structure
  function processFacetData(facets, excludedFacetNames = []) {
    // console.log("Processing facet data:", facets);
    // console.log('🔧 Excluding facets from collection filters:', excludedFacetNames);

    return facets.map(facet => {
      // console.log(`🔧 Processing facet: "${facet.name}"`);

      // Skip empty facets
      if (!facet.value || facet.value.length === 0) {
        // console.log(`🔧 Skipping empty facet: ${facet.name}`);
        return null;
      }

      // Skip internal facets
      if (facet.name.startsWith('v_') || facet.name.startsWith('p_')) {
        // console.log(`🔧 Skipping internal facet: ${facet.name}`);
        return null;
      }

      // Skip facets that are already applied as collection filters
      if (excludedFacetNames.includes(facet.name)) {
        // console.log(`🔧 Skipping facet "${facet.name}" - already applied as collection filter`);
        return null;
      }

      // console.log(`🔧 Keeping facet "${facet.name}" - not in collection filters`);

      const processedOptions = facet.value
        .map(option => {
          const processed = processFacetOption(option, facet);
          if (!processed) {
            // console.log(`Filtered out invalid option for facet ${facet.name}:`, option);
          }
          return processed;
        })
        .filter(Boolean); // Remove null results

      return {
        ...facet,
        processedOptions
      };
    }).filter(Boolean); // Remove null facets
  }

  // Build UI data structure for the filter component
  function buildFacetUI(facets, selectedFilters) {
    // console.log("Building facet UI with selected filters:", selectedFilters);

    const finishFamilyLookup = facetsLookup.filter((f) => f.name === 'v_colorGroupUrlLookup')[0];
    const finishLookup = facetsLookup.filter((f) => f.name === 'v_colorUrlLookup')[0];

    // console.log('Finish Family Lookup:', finishFamilyLookup);
    // console.log('Finish Lookup:', finishLookup);

    // Split name into separate keys for both lookups
    finishFamilyLookup.value = finishFamilyLookup.value.map((item) => {
      const [label, image] = item.name.split('|');

      return {
        ...item,
        label,
        image,
      };
    });

    finishLookup.value = finishLookup.value.map((item) => {
      const [label, image] = item.name.split('|');

      return {
        ...item,
        label,
        image,
      };
    });

    const resultsFilterData = facets.map((facet) => {
    if (facet.name === 'Finish Family') {
      const finishFamilyOptions = facet?.processedOptions.map((option) => {
        const finishFamilyImage = finishFamilyLookup?.value.filter((f) => f.label === option.text)[0]?.image;

        return {
          ...option,
          finishImage: finishFamilyImage || null,
        };
      });
      return {
        ...facet,
        processedOptions: finishFamilyOptions,
      };
    }

    if (facet.name === 'Finish') {
      const finishOptions = facet?.processedOptions.map((option) => {
        const finishImage = finishLookup?.value.filter((f) => f.label === option.text)[0]?.image;

        return {
          ...option,
          finishImage: finishImage || null,
        };
      });
      return {
        ...facet,
        processedOptions: finishOptions,
      };
    }

    return facet;
  });

  // console.log('Cleaned up facet data:', resultsFilterData);

    return resultsFilterData.map(facet => ({
      title: facet.name,
      key: facet.name,
      filters: facet.processedOptions
        .filter(option => option.count > 0) // Only show options with count > 0
        .map(option => ({
          label: option.text,
          value: option.value,
          count: option.count,
          selected: isFilterSelected(option.value, facet.name, selectedFilters),
          finishImage: facet.name === 'Finish Family' || facet.name === 'Finish' ? option.finishImage : null,
        })),
      expanded: false
    }));
  }

  // Check if a filter is currently selected
  function isFilterSelected(value, category, selectedFilters) {
    return selectedFilters.some(filter =>
      filter.facetTitle === category && filter.value === value
    );
  }





  // Function to determine the correct URL field based on environment
  function getProductUrl(product) {
    const currentHost = window.location.hostname;

    // Check if we're on the dev site
    if (currentHost.includes('moenstore-dev.myshopify.com')) {
      return product.v_urlDev || product.v_url || product.url || '';
    }

    // Production site or fallback
    return product.v_url || product.url || '';
  }

  // Function to get variant URL based on environment
  function getVariantUrl(variant) {
    const currentHost = window.location.hostname;

    // Check if we're on the dev site
    if (currentHost.includes('moenstore-dev.myshopify.com')) {
      return variant.v_urlDev || variant.v_url || '';
    }

    // Production site or fallback
    return variant.v_url || '';
  }

  // Function to build finishes object from variants array
  function buildFinishesObject(product) {
     if (!product.variants || !Array.isArray(product.variants) || product.variants.length === 0) {
    return [];
  }

  // console.log('Colors: ', product.colors);
  // console.log('Variants: ', product.variants);

    const finishes = product.variants.map((variant) => {

      return {
        name: variant.sku_color,
        model: variant.skuid || '', // Use the skuid as the model
          variant: { // make whole object for variant
              title: product.description,
              model: variant.skuid,
              image: {
                  type: 'image',
                  src: variant?.v_thumb_image?.[0],
                  alt: `${variant.sku_color} Finish`,
              },
              statusType: variant?.v_statusFlag?.[0]  ?  variant.v_statusFlag[0] : '',
              statusLabel: variant?.v_statusFlag?.[0]  ?  variant.v_statusFlag[0] : '',
          },
        v_url: getVariantUrl(variant), // Use environment-aware URL
        image: {
          type: "image",
          src: variant.v_colorSwatchUrl[0],
          alt: `${variant.sku_color} Finish`
        }
      };
    }).filter(finish => finish !== null); // Remove any null entries

    return finishes;
  }

  // Function to display products in the Neighborhood format
  function displayProducts(products, container) {
    if (!container) return;

    const productHTML = products.map((product, idx) => {
      // Get status from v_statusFlag in variants
      let statusType = "";
      let statusLabel = "";

      if (product.variants && product.variants.length > 0) {
        const firstVariant = product.variants[0];
        if (firstVariant.v_statusFlag) {
          statusType = firstVariant.v_statusFlag[0];
          statusLabel = firstVariant.v_statusFlag[0];
        }
      }

      // Build finishes object from variants array
      const finishesArray = buildFinishesObject(product);

      // Build finishes HTML elements
      const finishesHTML = finishesArray.length > 0 ?
        finishesArray.map(finish => `
          <nbhd-finish
            name="${finish.name || ''}"
            model="${finish.model || ''}"
            .variant="${finish.variant}"
            ${finish.v_url ? `href="${finish.v_url}"` : ''}
            image="${finish.image?.src || ''}"
            ${product.pid === finish.model ? 'active' : ''}
            slot="finish">
          </nbhd-finish>
        `).join('') : '';

      return `
        <nbhd-product-card
          id="product-card-${idx}"
          ${getProductUrl(product) ? `href="${getProductUrl(product)}"` : ''}
          ${product.pid ? `model="${product.pid}"` : ''}
          ${statusType === 'discontinued' ? 'discontinued' : ''}>
  
          ${statusType ? `
            <nbhd-badge
              variant="${statusType}"
              slot="status">
              ${statusLabel || statusType}
            </nbhd-badge>
          ` : ''}
  
          ${product.v_thumb_image ? `
            <nbhd-image
              width="300"
              height="300"
              slot="media"
              src="${product.v_thumb_image}"
              responsive
              alt="Product Image for ${product.description || ''} - ${product.pid || ''}">
            </nbhd-image>
          ` : `
            <nbhd-image
              width="300"
              height="300"
              slot="media"
              responsive
              src="https://embed.widencdn.net/img/moen/pwkqm95ygy/y400px@1x/64430.tif.jpg?q=100"
              alt="Default Product Image">
            </nbhd-image>
          `}
  
          ${product.v_image_alt1 ? `
            <nbhd-image
              width="300"
              height="300"
              slot="media-secondary"
              src="${product.v_image_alt1}"
              responsive
              alt="Product Image for ${product.description || ''} - ${product.pid || ''}">
            </nbhd-image>
          ` : ''}
  
          ${product.description ? `
            <nbhd-text tag="h3" slot="title" theme="light">
              ${product.description}
            </nbhd-text>
          ` : ''}
  
          ${product.pid ? `
            <nbhd-text slot="model" tag="div" theme="light">
              Model: ${product.pid}${product.v_requiresAPart_flag === "true" ? '*' : ''}
            </nbhd-text>
          ` : ''}
  
                    ${product.price_range && product.price_range.length >= 2 ? 
            product.price_range[0] === product.price_range[1] ? `
              <nbhd-text slot="price" tag="div" theme="light">
                ${formatCurrency(product.price_range[0])}
              </nbhd-text>
            ` : `
              <nbhd-text slot="price" tag="div" theme="light">
                ${formatCurrency(product.price_range[0])} - ${formatCurrency(product.price_range[1])}
              </nbhd-text>
            `
          : product.price ? `
            <nbhd-text slot="price" tag="div" theme="light">
              ${formatCurrency(product.price)}
            </nbhd-text>
          ` : ''}

          ${(() => {
            // Get exclusivity type from first variant
            let exclusive = "";
            if (product.variants && product.variants.length > 0) {
              const firstVariant = product.variants[0];
              if (firstVariant.v_exclusivityType) {
                exclusive = firstVariant.v_exclusivityType[0];
              }
            }
            return exclusive ? `
              <nbhd-text
                slot="exclusive"
                tag="div">
                ${exclusive}
              </nbhd-text>
            ` : '';
          })()}

          ${finishesHTML}
  
        </nbhd-product-card>
      `;
    }).join('');

    container.innerHTML = productHTML;

      // After setting innerHTML, we need to set the variant property on each nbhd-finish element
      // because we cannot set complex objects via HTML attributes
      // This is a workaround for the limitation of setting object properties in custom elements via HTML
      // We loop through each product card and set the variant property directly
      // This assumes that the nbhd-finish elements are in the same order as the finishesArray
      // which should be the case based on the above code
      products.forEach((product, idx) => {
          const card = container.querySelector(`#product-card-${idx}`);
          if (!card) return;
          const finishesArray = buildFinishesObject(product);
          const finishEls = card.querySelectorAll('nbhd-finish');
          finishesArray.forEach((finish, finishIdx) => {
              const finishEl = finishEls[finishIdx];
              if (finishEl) {
                  finishEl.variant = finish.variant;
              }
          });
      });
  }

